var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useLang } from '@shapeable/ui';
import { GptLayout } from '../elements/gpt-layout';
var cls = classNames('explorer-gpt-view-layout');
export var ExplorerGptViewLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n\n    .shp--gpt-output-header {\n      padding-top: ", ";\n    }\n\n    .shp--gpt-output-content,\n    .shp--gpt-output-header {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n\n    .shp--prompt-template-form {\n      padding-right: ", ";\n    }\n  "], ["\n    font-size: 1em;\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    padding-top: ", ";\n\n    .shp--gpt-output-header {\n      padding-top: ", ";\n    }\n\n    .shp--gpt-output-content,\n    .shp--gpt-output-header {\n      padding-left: ", ";\n      padding-right: ", ";\n    }\n\n    .shp--prompt-template-form {\n      padding-right: ", ";\n    }\n  "])), theme.UNIT(2), theme.UNIT(3), theme.UNIT(0), theme.UNIT(2), theme.UNIT(2), theme.UNIT(1))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n    border-top: 3px solid ", ";\n    border-radius: 0px 0px 8px 8px;\n    background: ", ";\n  "], ["\n    padding: ", " ", ";\n    border-top: 3px solid ", ";\n    border-radius: 0px 0px 8px 8px;\n    background: ", ";\n  "])), theme.UNIT(5), theme.UNIT(4), theme.COLOR('line-subtle'), theme.COLOR('brightWarm')),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0 ", " 0;\n  "], ["\n    margin: 0 ", " 0;\n  "])), theme.UNIT(5))
});
var IconHeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    padding-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    padding-bottom: ", ";\n  "])), theme.FONT_SIZE(32), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var GptLayoutStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\n    .shp--gpt-prompt {\n      border-top: none;\n      background: none;\n    }\n  "], ["\n\n    .shp--gpt-prompt {\n      border-top: none;\n      background: none;\n    }\n  "])))
});
var IntroStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: ", "em;\n    color: ", ";\n    line-height: 1.5em;\n  "], ["\n    font-size: ", "em;\n    color: ", ";\n    line-height: 1.5em;\n  "])), 14 / 13, theme.COLOR('text'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  GptLayout: styled(GptLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), GptLayoutStyles)
};
export var ExplorerGptViewLayout = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Body, null, React.createElement(My.GptLayout, null)), children);
};
ExplorerGptViewLayout.defaultProps = ExplorerGptViewLayoutDefaultProps;
ExplorerGptViewLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;